<template>
  <div class="zs-overlay" @click.self="$emit('close')">
    <div class="zs-card">
      <div class="zs-header">
        <div class="zs-left">
          <img src="../../../assets/meetings.png" style="height: 1.2rem" />
          <div class="zs-header-text">
            <div class="zs-title">MEETING</div>
            <div class="zs-subtitle">CHOOSE MEETING TYPE</div>
          </div>
        </div>
        <div class="zs-close" @click="$emit('close')"><i class="fa fa-times"></i></div>
      </div>

      <div class="zs-body">
        <div class="zs-options">
          <div class="zs-option-card" @click="$emit('choice', 'game-on')">
            <div class="zs-option-icon game-on">
              <i class="fa fa-gamepad"></i>
            </div>
            <div class="zs-option-content">
              <div class="zs-option-title">With Game-on</div>
              <div class="zs-option-desc">Automated breakout rooms for team-based play</div>
            </div>
            <div class="zs-option-arrow">
              <i class="fa fa-chevron-right"></i>
            </div>
          </div>

          <div class="zs-option-card" @click="$emit('choice', 'normal')">
            <div class="zs-option-icon normal">
              <i class="fa fa-video-camera"></i>
            </div>
            <div class="zs-option-content">
              <div class="zs-option-title">Without Game-on</div>
              <div class="zs-option-desc">Standard Zoom meeting for direct instruction</div>
            </div>
            <div class="zs-option-arrow">
              <i class="fa fa-chevron-right"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ZoomSelectionModal',
}
</script>

<style scoped>
.zs-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.75);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999999;
  font-family: Arial, sans-serif;
}

.zs-card {
  width: 500px;
  background: linear-gradient(180deg, #0d1a1a, #0b1517);
  border: 1px solid #1a3c40;
  border-radius: 12px;
  color: #fff;
  overflow: hidden;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.6);
}

.zs-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  border-bottom: 1px solid #1a3c40;
  background: #0d2525;
}

.zs-left {
  display: flex;
  align-items: center;
}

.zs-header-text {
  display: flex;
  flex-direction: column;
  margin-left: 12px;
}

.zs-title {
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 1px;
}

.zs-subtitle {
  font-size: 9px;
  color: #00ffff;
  letter-spacing: 0.5px;
  text-transform: uppercase;
}

.zs-close {
  cursor: pointer;
  color: #8c99a0;
  font-size: 18px;
  transition: 0.2s;
}

.zs-close:hover {
  color: #fff;
}

.zs-body {
  padding: 24px;
}

.zs-options {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.zs-option-card {
  display: flex;
  align-items: center;
  padding: 20px;
  background: rgba(26, 60, 64, 0.2);
  border: 1px solid #1a3c40;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.zs-option-card:hover {
  background: rgba(26, 60, 64, 0.4);
  border-color: #00ffff;
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(0, 255, 255, 0.1);
}

.zs-option-icon {
  width: 48px;
  height: 48px;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  margin-right: 20px;
}

.zs-option-icon.game-on {
  background: rgba(0, 255, 255, 0.1);
  color: #00ffff;
  border: 1px solid rgba(0, 255, 255, 0.3);
}

.zs-option-icon.normal {
  background: rgba(140, 153, 160, 0.1);
  color: #8c99a0;
  border: 1px solid rgba(140, 153, 160, 0.3);
}

.zs-option-content {
  flex: 1;
}

.zs-option-title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 4px;
}

.zs-option-desc {
  font-size: 12px;
  color: #8c99a0;
}

.zs-option-arrow {
  color: #1a3c40;
  font-size: 14px;
  transition: 0.3s;
}

.zs-option-card:hover .zs-option-arrow {
  color: #00ffff;
  transform: translateX(3px);
}
</style>
